import { usePostHog } from "posthog-js/react";
import { useRef } from "react";
import { useEffect } from "react";

export function useTrackCoursePageViewed() {
  const posthog = usePostHog();

  const once = useRef(false);

  useEffect(() => {
    if (once.current) return;
    once.current = true;
    posthog.capture("course_page_viewed");
  }, []);
}
